<script setup lang="ts">
export interface CiSuccessProps {
  message: string;
}
const props = withDefaults(defineProps<CiSuccessProps>(), {});

const { $gettext } = useGettext();
</script>

<template>
  <div>
    <div class="row">
      <div class="col-4 offset-4 col-md-4 offset-md-4 col-lg-2 offset-lg-5">
        <div class="mx-auto my-0 h-auto w-[90px]">
          <CiAnimatedCheck />
        </div>
      </div>
    </div>
    <div class="row mt-6">
      <div class="col-12 text-center">
        <h3>
          <span>{{ $gettext('Thank you.') }}</span>
        </h3>
        <p>{{ props.message }}</p>
      </div>
    </div>
  </div>
</template>

<style></style>
